module.exports = __webpack_public_path__ + "assets/img/video-play.b1b63c26.webp";